module.exports = __webpack_public_path__ + "static/media/teaser-lohnvergleich.5cf0c2e4.jpg";